import React, { FC } from 'react';
import styles from './decision_upload_warning_components.module.scss';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';

export const DecisionUploadWarningContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);

export const DecisionUploadWarningTitle: FC = ({ children }) => (
  <div className={styles.title}>{children}</div>
);

export const DecisionUploadWarningIcon: FC = () => (
  <MaterialIcon name="error_outline" className={styles.icon} />
);
